export default __webpack_public_path__ + "72bf37daad54706edc9463a091a20607.png";